import translations, { Language, TranslationKeys } from "./translations";

const STORAGE_KEY = "language";

/**
 * Detect browser language
 * Only Spanish ("es") is allowed, everything else -> English
 */
const detectBrowserLanguage = (): Language => {
  if (typeof window === "undefined") return "en";

  const browserLang =
      navigator.languages?.[0] || navigator.language || "en";

  return browserLang.toLowerCase().startsWith("es") ? "es" : "en";
};

/**
 * Set language explicitly (user choice)
 */
export const setLanguage = (lang: Language) => {
  localStorage.setItem(STORAGE_KEY, lang);
};

/**
 * Get language
 * Priority: localStorage → browser → fallback en
 */
export const getLanguage = (): Language => {
  if (typeof window === "undefined") return "en";

  const savedLang = localStorage.getItem(STORAGE_KEY) as Language | null;

  if (savedLang === "en" || savedLang === "es") {
    return savedLang;
  }

  const detectedLang = detectBrowserLanguage();
  localStorage.setItem(STORAGE_KEY, detectedLang);

  return detectedLang;
};

/**
 * Translation helper
 */
export const i18n = (
    key: TranslationKeys,
    params?: Record<string, string>
): string => {
  const language = getLanguage();
  // @ts-ignore
  const translation = translations[language]?.[key] || key;

  if (params) {
    return Object.keys(params).reduce(
        (str, paramKey) =>
            str.replace(`{${paramKey}}`, params[paramKey]),
        translation
    );
  }

  return translation;
};
